import { createFileRoute, redirect } from "@tanstack/react-router";

import { CoachProfileEditorPage } from "src/pages/CoachProfileEditorPage";

export const Route = createFileRoute("/_auth/_coach/profile/$section")({
  beforeLoad({ params }) {
    if (params.section !== "links" && params.section !== "design") {
      throw redirect({
        to: "/profile/$section",
        params: { section: "links" },
      });
    }
  },
  component: CoachProfileEditorPage,
});
